import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as galleryImageActions from '../../actions/gallery/galleryImageActions';
import * as modalActions from '../../actions/common/modalActions';
import {Link} from 'react-router-dom';
import {toastr} from 'react-redux-toastr';
import {FormattedMessage, injectIntl} from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import Placeholder from "../Placeholder";
import PlaceholderError from "../common/PlaceholderError";
import ResetFormModal from "../ResetFormModal";
import PrivateAPIResource from "../../services/PrivateAPIResource";
import {plainJSTranslator} from "../../common/PlainJSTranslator";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import ResetButton from "../common/ResetButton";

class GalleryImageCropPage extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.onImageLoaded = this.onImageLoaded.bind(this);
        this.onCropComplete = this.onCropComplete.bind(this);
        this.onCropChange = this.onCropChange.bind(this);
        this.cropOriginalImage = this.cropOriginalImage.bind(this);

        this.state = {
            src: null,
            crop: {
                unit: "%",
                width: 50,
                height: 50
                // aspect: 16 / 9
            },
            croppedImageUrl: null,

            originalCrop: {
                x: 0,
                y: 0,
                w: 0,
                h: 0
            },

            isUpdating: false
        };

        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        let actions = [];

            actions.push(this.props.actions.loadGalleryImage(
                this.props.match.params.galleryId,
                this.props.match.params.id
            ));
        return actions;
    }

    convertImgToBase64URL(url, callback, outputFormat){
        let img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function(){
            let canvas = document.createElement('canvas'),
                ctx = canvas.getContext('2d'), dataURL;
            canvas.height = img.height;
            canvas.width = img.width;
            ctx.drawImage(img, 0, 0);
            dataURL = canvas.toDataURL(outputFormat);
            callback(dataURL);
            canvas = null;
        };
        img.src = url;
    }
    componentDidMount() {
        if (this.props.galleryImage.filePath !== '') {
            let timestamp = (new Date()).getTime();
            this.convertImgToBase64URL(this.props.galleryImage.filePath + '?' + timestamp, (img64) => {
                this.setState({
                    src: img64,
                })
            });
        }
    }

    componentDidUpdate (prevProps) {
        if (prevProps.galleryImage.filePath !== this.props.galleryImage.filePath) {
            let timestamp = (new Date()).getTime();
            this.convertImgToBase64URL(this.props.galleryImage.filePath + '?' + timestamp, (img64) => {
                this.setState({
                    src: img64,
                })
            });
        }
    }

    redirect() {
        this.context.router.history.push('/galleri/vis/' + this.props.match.params.galleryId);
    }

    onImageLoaded(image) {
        this.imageRef = image;
    };

    onCropComplete(crop) {
        this.makeClientCrop(crop);
    };

    onCropChange(crop, percentCrop) {
        // You could also use percentCrop:
        this.setState({ crop: percentCrop });
        // this.setState({ crop });
    };

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                "newFile.jpeg"
            );
            this.setState({ croppedImageUrl });
        }
    }

    getCroppedImg(image, crop, fileName) {
        let canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext("2d");
        this.setState({
            originalCrop: {
                x: crop.x * scaleX,
                y: crop.y * scaleY,
                w: crop.width * scaleX,
                h: crop.height * scaleY,
            }
        });
        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    //reject(new Error('Canvas is empty'));
                    console.error("Canvas is empty");
                    return;
                }
                blob.name = fileName;
                window.URL.revokeObjectURL(this.fileUrl);
                this.fileUrl = window.URL.createObjectURL(blob);
                resolve(this.fileUrl);
            }, "image/jpeg");
        });
    }

    cropOriginalImage() {
        this.setState({
            isUpdating: true
        });
        let galleryId = this.props.galleryImage.galleryId;
        let imageId = this.props.galleryImage.id;
        PrivateAPIResource.put(`gallery/crop-image/${galleryId}/${imageId}`, {
            x: this.state.originalCrop.x,
            y: this.state.originalCrop.y,
            width: this.state.originalCrop.w,
            height: this.state.originalCrop.h,
        }).then(() => {
            this.setState({
                isUpdating: false
            });
            toastr.success('Billede uploadet');
            this.redirect();
        }).catch(error => {
            console.log(error);
            toastr.error(error);
            // toastr.error('Kunne ikke uploade billedet');
        })
    }

    render() {

        const { crop, croppedImageUrl, src } = this.state;

        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
                <div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card m-b-20">
                                <div className="card-block">
                                    <div className="row">
                                        <div className="col-12">
                                            <h1 className="m-b-30">Billede beskæring</h1>
                                        </div>

                                    </div>
                                    {src && (
                                        <div className="row">
                                            <div className="col-12">
                                                <ReactCrop
                                                    src={src}
                                                    crop={crop}
                                                    onImageLoaded={this.onImageLoaded}
                                                    onComplete={this.onCropComplete}
                                                    onChange={this.onCropChange}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {croppedImageUrl && (
                                        <div className="row">
                                            <div className="col-12">
                                                <img alt="Crop" style={{ maxWidth: "100%" }} src={croppedImageUrl} />
                                            </div>
                                        </div>
                                    )}
                                    <hr />
                                    <div className="row">
                                        <div className="col-sm-12 offset-sm-2">
                                            {
                                                !this.state.isUpdating &&
                                                <button
                                                    onClick={this.cropOriginalImage}
                                                    className="btn btn-primary waves-effect waves-light clickable btn-m"
                                                >
                                                    Beskær
                                                </button>
                                            }
                                            {
                                                this.state.isUpdating &&
                                                <button
                                                    disabled
                                                    onClick={this.cropOriginalImage}
                                                    className="btn btn-primary waves-effect waves-light clickable btn-m disabled"
                                                >
                                                    Arbejder...
                                                </button>

                                            }
                                            <Link
                                                to={`/galleri/vis/${this.props.match.params.galleryId}`}
                                                className="btn btn-secondary waves-effect ml-3"
                                            >
                                                Tilbage til galleriet
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </WithResolvedPromises>
        )
    }
}

GalleryImageCropPage.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {

    return {
        galleryImage: state.galleryImage,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...galleryImageActions,
        }, dispatch)
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(GalleryImageCropPage));




// WEBPACK FOOTER //
// ./web/src/components/galleries/GalleryImageCropPage.jsx